/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import './style.css';
import Link , {navigateTo} from "gatsby-link";
import CookieBanner, {Cookies} from 'react-cookie-banner';
import * as actions_cookies from '../../actions/cookieconsent';

const cookies = new Cookies;

var d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
var expiry = new Date(year + 1, month, day);


class AlertLink extends Component {
  constructor (props) {
    super(props);
    this.state = {
      cookies_all: this.props.cookies_all
    };
    this._enable_all_cookies = this._enable_all_cookies.bind(this);

  };


  _enable_all_cookies( ){
    this.props.enable_all_cookies();

    cookies.set('ub_cc', true, {
      expires: expiry
})

    this.setState({cookies_all: true});

    navigateTo('/');


  }






    render(props) {



        return (
          <div>

        {  this.props.cookies_all === false ?
        <button className="button-close" onClick={ ()=> this._enable_all_cookies() }>
              EINVERSTANDEN
          </button>
          :
          ''
        }
        </div>
        );






    }
  }
  AlertLink.propTypes = {


  };



  const mapStateToProps = ({  cookies_all, enable_all_cookies }) => {
    return { cookies_all, enable_all_cookies }
  }

  const mapDispatchToProps = dispatch => {
    return {
      enable_all_cookies: () => dispatch(actions_cookies.enable_all_cookies()),
     }
  }

  const ConnectedAlertLink = connect(mapStateToProps, mapDispatchToProps)(AlertLink)

  export default ConnectedAlertLink



// WEBPACK FOOTER //
// ./src/components/ConnectedCookieConsent/ConnectedAlertLink.js